import { gql } from '@edreamsodigeo/frontend-api-client';

export const updateMembershipProduct = gql`
  mutation updateMembership(
    $updateMembershipProductRequest: UpdateMembershipProductRequest
  ) {
    updateMembershipProduct(
      updateMembershipProductRequest: $updateMembershipProductRequest
    ) {
      offerAdded {
        offerId
      }
    }
  }
`;

export const getMembership = gql`
  query MembershipProduct(
    $membershipProductRequest: GetMembershipProductRequest
  ) {
    membershipProduct(membershipProductRequest: $membershipProductRequest) {
      offerAdded {
        price {
          amount
          currency
        }
        offerId
        productId
      }
      primeMember {
        name
        lastNames
      }
    }
  }
`;

export const membershipProductEvaluation = gql`
  mutation UpdateMembershipProductEvaluation(
    $request: MembershipProductEvaluationRequest
  ) @silent {
    membershipProductEvaluation(request: $request) {
      code
    }
  }
`;

export const getUserMembership = gql`
  query UserMembership($userAccountRequest: UserAccountRequest) {
    userAccount(userAccountRequest: $userAccountRequest) {
      userMembership {
        isActive
        subscriptionDetails {
          expirationDate
          isAutoRenewalEnabled
        }
      }
    }
  }
`;

export const updateUserMembershipMutation = gql`
  mutation UpdateUserMembership($action: UpdateUserMembershipAction!) {
    updateUserMembership(updateUserMembershipRequest: { action: $action }) {
      autoRenewalStatus
    }
  }
`;
